import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import {
  clearDeferredOnboardingReturn,
  getDeferredOnboardingReturn,
  getDeferredOnboardingUrl,
} from './onboardingDeferredReturn';

/**
 * مدیریت دکمه بک اندروید
 * این فایل رفتار دکمه بک را کنترل می‌کند
 */

let backButtonListenerAdded = false;

export const setupAndroidBackButton = (navigate: (to: string | number) => void) => {
  // فقط برای اندروید
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') {
    return;
  }

  // جلوگیری از اضافه کردن چندباره listener
  if (backButtonListenerAdded) {
    return;
  }

  backButtonListenerAdded = true;

  App.addListener('backButton', ({ canGoBack }) => {
    const currentPath = window.location.pathname;

    if (currentPath === '/onboarding/phone') {
      const deferredReturn = getDeferredOnboardingReturn();
      if (deferredReturn) {
        clearDeferredOnboardingReturn();
        navigate(getDeferredOnboardingUrl(deferredReturn));
        return;
      }
    }
    
    // صفحات auth/onboarding که نباید به آنها برگشت (با exact match)
    const authRoutes = [
      '/welcome',
      '/login',
      '/otp-verification',
      '/onboarding/topics',
      '/onboarding/books',
      '/onboarding/phone',
      '/onboarding/read',
      '/onboarding/novel-read',
      '/onboarding/xp-claim',
      '/onboarding/streak',
      '/onboarding/achievement'
    ];
    
    // صفحات onboarding که back navigation خاص دارند
    const onboardingBackMap: Record<string, string> = {
      '/onboarding/otp-verification': '/onboarding/phone',
      '/onboarding/name': '/onboarding/phone',
    };
    
    // اگر در صفحات onboarding با back navigation خاص هستیم
    if (onboardingBackMap[currentPath]) {
      navigate(onboardingBackMap[currentPath]);
      return;
    }

    // اگر در dashboard هستیم و کاربر بک زد، اپ را minimize کن
    if (currentPath === '/dashboard') {
      App.minimizeApp();
      return;
    }
    
    // اگر در صفحات auth هستیم که نباید back بزنیم، اپ را minimize کن (با exact match)
    if (authRoutes.some(route => currentPath === route || currentPath.startsWith(route + '/'))) {
      App.minimizeApp();
      return;
    }
    
    // برای بقیه صفحات، اگر history وجود دارد برگرد
    if (canGoBack) {
      navigate(-1);
    } else {
      // اگر در صفحه اول هستیم، اپ را minimize کن
      App.minimizeApp();
    }
  });

  console.log('✅ Android back button handler registered');
};

export const removeAndroidBackButton = () => {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') {
    return;
  }

  App.removeAllListeners();
  backButtonListenerAdded = false;
  console.log('🗑️ Android back button handler removed');
};
